import { BankAccountDetails, PaymentProviderBankDetails } from '@/interfaces/bank-account';
import {
  AccountLookup,
  AccountLookupInformation,
  CreateAccountPassword,
  ResetAccountPassword
} from '@/interfaces/account';
import { Response } from '@/interfaces/api';
import api from '~/api/client';
import { CONSUMER_API_PATH } from './config';

export function accountLookup(lookupData: AccountLookup): Promise<void> {
  return api.baseClient.post(`${CONSUMER_API_PATH}/validate/`, lookupData);
}

export function getInformationFromToken(token: string): Response<AccountLookupInformation> {
  return api.baseClient.get(`${CONSUMER_API_PATH}/tokens/${token}/information/`);
}

export function createAccountPassword(
  data: CreateAccountPassword
): Response<CreateAccountPassword> {
  return api.baseClient.post(`${CONSUMER_API_PATH}/validate-token/`, data);
}

export function resetAccountPassword(data: ResetAccountPassword): Response<ResetAccountPassword> {
  return api.baseClient.post(`${CONSUMER_API_PATH}/password-forget-confirm/`, data);
}

export function sendBankDeposits(bankDetails: BankAccountDetails): Response<void> {
  return api.client.post(`${CONSUMER_API_PATH}/onboarding/begin/`, bankDetails);
}

export function reinitiateMicroDeposits(): Response<void> {
  return api.client.post(`${CONSUMER_API_PATH}/onboarding/re-initiate-micro-deposits/`);
}

export function verifyBankDeposits(deposits: string[]): Response<void> {
  return api.client.post(`${CONSUMER_API_PATH}/onboarding/verify/`, {
    micro_deposits_amounts: deposits
  });
}

export function checkBankAccountDetails(): Response<PaymentProviderBankDetails> {
  return api.client.get(`${CONSUMER_API_PATH}/bank/`);
}
